import { FC } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';

import Location from 'services/Location';
import { LoginButton } from 'routes/login-button/LoginButton';
import { Ooops } from 'routes/ooops/Ooops';

const SignInHandler: FC = () => {
  const [searchParams] = useSearchParams();
  const identityException = searchParams.get('identity_exception') || 'unauthorized';
  const exceptionDetails = searchParams.get('exception_details');

  const error: any = { identity_exception: identityException };

  if (exceptionDetails) {
    error.exception_details = exceptionDetails;
  }

  if (identityException === 'identity_lost') {
    Location.sendPostMessage({ signed_out: true });
  } else {
    Location.sendPostMessage({ error });
  }

  return null;
};

const IframeRouter: FC = () => {
  const identityException = Location.getUrlParam('identity_exception');
  const oauthException = Location.getUrlParam('oauth_exception');
  const exceptionDetails = Location.getUrlParam('exception_details');
  const requestId = Location.getUrlParam('request_id');

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignInHandler />} />
        <Route path="/signin" element={<SignInHandler />} />
        <Route path="/login-button/success" element={<LoginButton />} />
        <Route
          path="/ooops"
          element={
            <Ooops
              flow="button"
              identityException={identityException}
              oauthException={oauthException}
              exceptionDetails={exceptionDetails}
              requestId={requestId}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default IframeRouter;
